import { useEffect } from "react";

export function useSendBeaconOnUnload({ data, url, enabled = true }) {
  useEffect(() => {
    if (!enabled || typeof navigator.sendBeacon !== "function") return;

    const handleUnload = () => {
      // Send the data
      const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    };

    window.addEventListener("unload", handleUnload);
    return () => window.removeEventListener("unload", handleUnload);
  }, [data, url, enabled]);
}
